import '@/App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

import Nav from '@/sections/Nav';
import Hero from '@/sections/Hero';
import Introduction from '@/sections/Introduction';
import Services from '@/sections/Services';
import Expertise from '@/sections/Expertise';
import Approach from '@/sections/Approach';
import Contact from '@/sections/Contact';
import Footer from '@/sections/Footer';
import { useReveal } from '@/hooks/useReveal';

const PAGE_TITLE = 'sejal patil | Strategy & Management Consulting';

function LandingPage() {
  useReveal();
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);
  return (
    <div className="App">
      <Nav />
      <main>
        <Hero />
        <Introduction />
        <Services />
        <Expertise />
        <Approach />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
